
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("a0Cao", function(module, exports) {
/* SpaceViewsMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9VJDA = parcelRequire("9VJDA");


var $inPa6 = parcelRequire("inPa6");


var $4kfV4 = parcelRequire("4kfV4");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $4AkKf = parcelRequire("4AkKf");


var $1qfLF = parcelRequire("1qfLF");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $epLE5 = parcelRequire("epLE5");


var $2vuKf = parcelRequire("2vuKf");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");




const $90e7d6468ec2564b$export$edb9b52ab3f1abbb = (ref)=>{
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
        // eslint-disable-next-line
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $42omo.useEffect)(()=>{
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return ()=>{
                observer.disconnect();
            };
        });
        return isIntersecting;
    }
};



const $4dd7628757ed68c6$var$SpaceViewsMenuContentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UQZ8V",
    name: "SpaceViewsMenuContentLoader",
    loader: async ()=>(await (parcelRequire("hwXXL"))).SpaceViewsMenuContent
});

const $4dd7628757ed68c6$var$useLazyOptionClickedAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("cXwni"))).fireSpaceViewsOptionClickedAnalytics);

const $4dd7628757ed68c6$var$useLazyTriggerClickedAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("cXwni"))).fireSpaceViewsTriggerClickedAnalytics);
const $4dd7628757ed68c6$var$i18n = (0, $aXWIB.defineMessages)({
    menuTooltipForContent: {
        id: "space-views.space.menu.tooltip.content",
        defaultMessage: "Change view"
    },
    disabledMenuTooltipForContent: {
        id: "space-views.space.menu.tooltip.content.disabled",
        defaultMessage: "Filtering is disabled when editing multiple items"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dd7628757ed68c6$var$CustomPopupContainerWithToken = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1pby15gg _bfhk1bhr _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dd7628757ed68c6$var$CustomPopupContainerWithoutToken = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1l7b _1pby15gg _bfhk1bhr _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // same styles as a tooltip but with narrower width (FG + fallback for borderRadius)
const $4dd7628757ed68c6$var$tooltipStylesWithToken = null;
const $4dd7628757ed68c6$var$tooltipStylesWithoutToken = null;
const $4dd7628757ed68c6$var$ToolTipOverride = /*#__PURE__*/ (0, $42omo.forwardRef)(function ToolTipOverride({ children: children, tooltipStyles: tooltipStyles, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            tooltipStyles ?? "_11q71aqn _2rko12b0 _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f25rb"
        ])
    }, children);
});
const $4dd7628757ed68c6$export$c0941f68287dbcd1 = ({ selection: selection, setSelection: setSelection, intl: intl, isWhiteboardBetaEnabled: isWhiteboardBetaEnabled, edition: edition, canManageContentOrSuperAdmin: canManageContentOrSuperAdmin, triggerRef: externalTriggerRef })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const ref = (0, $42omo.useRef)(null);
    const isVisible = (0, $90e7d6468ec2564b$export$edb9b52ab3f1abbb)(ref);
    (0, $42omo.useEffect)(()=>{
        if (!isVisible) {
            if (isOpen) setIsOpen(false);
        }
    }, [
        isVisible,
        isOpen
    ]);
    const fireOptionClickedAnalytics = $4dd7628757ed68c6$var$useLazyOptionClickedAnalytics(createAnalyticsEvent, selection);
    const setAndClose = (0, $42omo.useCallback)((option)=>{
        setSelection(option);
        setIsOpen(false);
        fireOptionClickedAnalytics(option);
    }, [
        setSelection,
        fireOptionClickedAnalytics
    ]);
    const fireTriggerClickedAnalytics = $4dd7628757ed68c6$var$useLazyTriggerClickedAnalytics(createAnalyticsEvent, selection);
    const onTriggerClick = (0, $42omo.useCallback)(()=>{
        setIsOpen((o)=>!o);
        fireTriggerClickedAnalytics();
    }, [
        fireTriggerClickedAnalytics
    ]);
    const CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>(0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dd7628757ed68c6$var$CustomPopupContainerWithToken, {
            ...props,
            ref: ref
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dd7628757ed68c6$var$CustomPopupContainerWithoutToken, {
            ...props,
            ref: ref
        }, children));
    const tooltipOptions = {
        position: 'bottom-end',
        component: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dd7628757ed68c6$var$ToolTipOverride, {
                ...p,
                tooltipStyles: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $4dd7628757ed68c6$var$tooltipStylesWithToken : $4dd7628757ed68c6$var$tooltipStylesWithoutToken
            })
    };
    const getTriggerButton = (triggerProps)=>{
        // Combine the popup's ref with external ref (if provided)
        const combinedRef = (element)=>{
            // Set the popup system's ref
            if (triggerProps.ref) {
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
                else triggerProps.ref.current = element;
            } // Set external ref if provided - this connects our parent's ref to the DOM element
            if (externalTriggerRef) externalTriggerRef.current = element;
        };
        if (edition === 'PREMIUM' && canManageContentOrSuperAdmin && (0, $6mKj3.expVal)('confluence_bulk_actions_in_content_tree', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...triggerProps,
            ref: combinedRef,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))),
            onClick: onTriggerClick,
            isSelected: isOpen,
            label: isMultiSelectActive ? intl.formatMessage($4dd7628757ed68c6$var$i18n.disabledMenuTooltipForContent) : intl.formatMessage($4dd7628757ed68c6$var$i18n.menuTooltipForContent),
            isDisabled: isMultiSelectActive,
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...triggerProps,
            ref: combinedRef,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: onTriggerClick,
            isSelected: isOpen,
            label: intl.formatMessage($4dd7628757ed68c6$var$i18n.menuTooltipForContent),
            spacing: "compact",
            appearance: "subtle"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        "data-vc": "space-views-menu",
        ...ssrPlaceholderIdProp
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
        isTinted: false,
        shouldAllowClickThrough: !isOpen,
        onBlanketClicked: handleClose,
        testId: "space-views-menu-blanket"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: handleClose,
        content: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dd7628757ed68c6$var$SpaceViewsMenuContentLoader, {
                selection: selection,
                setSelection: setAndClose,
                intl: intl,
                ...props
            }),
        popupComponent: CustomPopupContainer,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4dd7628757ed68c6$var$i18n.menuTooltipForContent),
                position: isWhiteboardBetaEnabled ? 'top' : 'bottom',
                hideTooltipOnMouseDown: true
            }, getTriggerButton(triggerProps))),
        placement: "bottom-start",
        shouldRenderToParent: true
    }));
};
const $4dd7628757ed68c6$export$74e94f45f06d0cbd = (0, $aXWIB.injectIntl)($4dd7628757ed68c6$export$c0941f68287dbcd1);
module.exports["MenuComponent"] = $4dd7628757ed68c6$export$c0941f68287dbcd1;
module.exports["SpaceViewsMenu"] = $4dd7628757ed68c6$export$74e94f45f06d0cbd;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("hwXXL", function(module, exports) {

let $cc33f0338d663b1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc33f0338d663b1c$var$load("6wr18"),
    $cc33f0338d663b1c$var$load("ffEVr"),
    $cc33f0338d663b1c$var$load("cWvhX")
]).then(()=>parcelRequire('4IxWt'));

});

parcelRegister("cXwni", function(module, exports) {

let $96f41bb159a9a46d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f41bb159a9a46d$var$load("SepNY").then(()=>parcelRequire('kb7fE'));

});


//# sourceMappingURL=SpaceViewsMenu.87eca7fe.js.map
